export default __webpack_public_path__ + "static/media/mandala.024fb640.jpg";